import palette from '../palette';

const MuiCheckbox = {
  root: {
    color: palette.text.placeholder,
  },
};

export default MuiCheckbox;
